module.exports = __webpack_public_path__ + "media/discovery-ui/assets/social/twitter-white-ec5eb765af87179379636c798c633232.svg";